module.exports = __webpack_public_path__ + "resources/polls-30ae277da96d0ebfa6dac0b385aa8630.svg";